import { render } from "./CategoryButtons.vue?vue&type=template&id=0143f498&scoped=true"
import script from "./CategoryButtons.vue?vue&type=script&lang=js"
export * from "./CategoryButtons.vue?vue&type=script&lang=js"

import "./CategoryButtons.vue?vue&type=style&index=0&id=0143f498&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0143f498"]])

export default __exports__